import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";
import { Badge, Button, Card, EmptyState, PageHeader, Spinner, statusTone, Table } from "../components/ui";
import { STATUS_LABELS, fmtDate, fmtPct } from "../lib/format";

export function Reports() {
  const { data, isLoading } = useQuery({
    queryKey: ["reports-list"],
    queryFn: () => api<{ items: any[] }>("/tests?status=completed&pageSize=50"),
  });
  return (
    <div>
      <PageHeader title="Reports" subtitle="Completed tests with full placement, authentication, and blacklist reports" />
      <Card className="p-0">
        {isLoading ? <Spinner /> : !data?.items.length ? (
          <div className="p-6"><EmptyState title="No completed reports" description="Once a test completes, its full report appears here." action={<Link to="/tests/new"><Button>Create a test</Button></Link>} /></div>
        ) : (
          <Table headers={["Test", "Status", "Inbox %", "Spam %", "Score", "Created", ""]}>
            {data!.items.map((t: any) => (
              <tr key={t.id} className="table-row-hover">
                <td className="px-4 py-3 font-medium text-ink-800">{t.name}</td>
                <td className="px-4 py-3"><Badge tone={statusTone(t.status)}>{STATUS_LABELS[t.status]}</Badge></td>
                <td className="px-4 py-3 text-emerald-600">{fmtPct(t.options?.summary?.inboxPct)}</td>
                <td className="px-4 py-3 text-red-600">{fmtPct(t.options?.summary?.spamPct)}</td>
                <td className="px-4 py-3 font-semibold text-ink-800">{t.options?.summary?.deliverabilityScore ?? "—"}</td>
                <td className="px-4 py-3 text-ink-500">{fmtDate(t.createdAt)}</td>
                <td className="px-4 py-3">
                  {t.latestRunId && <Link to={`/tests/${t.id}/runs/${t.latestRunId}`}><Button size="sm" variant="secondary">Open report</Button></Link>}
                </td>
              </tr>
            ))}
          </Table>
        )}
      </Card>
    </div>
  );
}
